import { render, staticRenderFns } from "./BLK3PreCode.vue?vue&type=template&id=1c4fcfc2"
import script from "./BLK3PreCode.vue?vue&type=script&lang=js"
export * from "./BLK3PreCode.vue?vue&type=script&lang=js"
import style0 from "./BLK3PreCode.vue?vue&type=style&index=0&id=1c4fcfc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports